<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Portfolio Categories</h2>
          </header>
        </div>
      </div>
      <div class="inputCard">
        <header>Categories</header>
        <div class="content">
          <div class="input-row-button w3-padding-8 w3-border-bottom">
            <input v-model="newCategory.title" placeholder="Category Name" class="w3-input w3-border" style="border-radius:5px;" />
            <div class="w3-right-align">
              <button class="w3-button w3-small w3-green" @click="addCategory()">Add</button>
            </div>
          </div>
          <div class="categoriesGrid w3-padding-8 w3-border-bottom">
            <div class="categoryName"><b>Name</b></div>
            <div class="w3-right-align"><b>Actions</b></div>
          </div>
          <template v-if="state.siteData.content.portfolio.categories.length > 0">
            <div class="categoriesGrid w3-padding-8" v-for="(category, index) in state.siteData.content.portfolio.categories" :key="index">
              <div class="categoryName">{{category.title}}</div>
              <div class="buttons">
                <button class="w3-button w3-small w3-red" @click="deleteCategory(category.id)"><i class="fa fa-trash"></i></button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="w3-padding">
              No Categories Found
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsportfoliocategories',
  data() {
    return {
      state: dataStore.state,
      newCategory: {
        id: 0,
        title: '',
        slug: ''
      }
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteCategory(id) {
      let itemIndex = this.state.siteData.content.portfolio.categories.findIndex(savedCategory => savedCategory.id === id)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.portfolio.categories[itemIndex].title + ' category?')) {
          this.state.siteData.content.portfolio.categories.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    },
    addCategory() {
      this.newCategory.id = Math.max(...this.state.siteData.content.portfolio.categories.map(o => o.id), 0) + 1
      this.newCategory.slug = slug(this.newCategory.title)
      this.state.siteData.content.portfolio.categories.push(this.newCategory)
      this.newCategory = {
        id: 0,
        title: '',
        slug: ''
      }
      this.saveContent()
    }
  }
}
</script>

<style scoped>
  .categoriesGrid {display:grid; grid-template-columns: 1fr 75px; border-bottom: 1px solid #ccc;}
  .categoriesGrid:last-child {border-bottom:0;}
  .categoriesGrid .buttons button {padding:6px 10px;}
  .categoryName {padding-left:8px;}
  .input-row-button {display:grid; grid-template-columns: 1fr 60px; grid-gap: 8px;}

  .portfolioContentGrid {display:grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); grid-gap: 8px;}
  .cardImage {height:150px; width:100%; overflow:hidden; background-position: center; background-size: cover;}

  .headerRightGrid {display: grid; grid-template-columns: 1fr 115px; grid-gap:8px;}

  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsPortfolioCategories.vue